// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/firstparty/v4/deactivate_payment_link.proto

/* eslint-disable */
import { ApiPaymentLink } from "./payment_link";

/** Request message for DeactivatePaymentLink */
export interface ApiDeactivatePaymentLinkRequest {
  /** The unique identifier for the payment link (from path parameter) */
  readonly paymentLinkId: string;
}

/** Response message for DeactivatePaymentLink */
export interface ApiDeactivatePaymentLinkResponse {
  /** The deactivated payment link */
  readonly paymentLink: ApiPaymentLink | null;
}

export const ApiDeactivatePaymentLinkRequest: MessageFns<ApiDeactivatePaymentLinkRequest> = {
  fromJSON(object: any): ApiDeactivatePaymentLinkRequest {
    return { paymentLinkId: isSet(object.payment_link_id) ? globalThis.String(object.payment_link_id) : "" };
  },

  toJSON(message: ApiDeactivatePaymentLinkRequest): unknown {
    const obj: any = {};
    if (message.paymentLinkId !== undefined && message.paymentLinkId !== null) {
      obj.payment_link_id = message.paymentLinkId;
    }
    return obj;
  },
};

export const ApiDeactivatePaymentLinkResponse: MessageFns<ApiDeactivatePaymentLinkResponse> = {
  fromJSON(object: any): ApiDeactivatePaymentLinkResponse {
    return { paymentLink: isSet(object.payment_link) ? ApiPaymentLink.fromJSON(object.payment_link) : null };
  },

  toJSON(message: ApiDeactivatePaymentLinkResponse): unknown {
    const obj: any = {};
    if (message.paymentLink !== undefined && message.paymentLink !== null) {
      obj.payment_link = ApiPaymentLink.toJSON(message.paymentLink);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
